import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { ContextType, FundViewExpense, FundsInterface } from '../types/types';

const Context = createContext<ContextType | undefined>(undefined);

export const FundContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [fundDetail, setFundExpense] = useState<FundsInterface | null>(() => {
      const storedData = localStorage.getItem("fundDetail");
      return storedData ? JSON.parse(storedData) : null;
    });

  
   useEffect(() => {
    if (fundDetail) {
      localStorage.setItem("fundDetail", JSON.stringify(fundDetail));
    }
  }, [fundDetail]);


  const value = useMemo(
    () => ({
      fundDetail,
      setFundExpense,
    }),
    [fundDetail]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useFundContext = (): ContextType => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useExpenseContext must be used within an ExpenseProvider');
  }
  return context;
};
